import { faSchool } from "@fortawesome/free-solid-svg-icons";

/** Nav icon for playgrounds: evokes a school playground, not a code editor. */
export const playgroundNavIcon = faSchool;
